
import { Progress } from "element-ui"
import slotWidget from "./slot-widget"
import freeGiftDrawer from "./free-gift-drawer"

export default {
  components: {
    [Progress.name]: Progress,
    slotWidget,
    freeGiftDrawer
  },
  props: {
    coreData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    handleOpen() {
      this.$refs.freeGiftDrawer.open()
    }
  }
}
